import { createMuiTheme } from "@material-ui/core/styles"
import color from "./color"

const defaultTheme = createMuiTheme()
export const { breakpoints } = defaultTheme

export default createMuiTheme({
  typography: {
    useNextVariants: true,
    fontFamily: "Poppins",
    h1: {
      fontSize: "3.875rem",
      lineHeight: "4.125rem",
      fontWeight: 300,
      letterSpacing: "-0.77px",
      [breakpoints.down("xs")]: {
        fontSize: "2.2rem",
        lineHeight: "2.2rem"
      }
    },
    h2: {
      fontSize: "2.25rem",
      lineHeight: "2.875rem",
      fontWeight: 400,
      letterSpacing: "-0.64px",
      [breakpoints.down("xs")]: {
        fontSize: "1.875rem",
        lineHeight: "1.875rem"
      }
    },
    h3: {
      fontSize: "1.75rem",
      lineHeight: "2rem",
      fontWeight: 400,
      letterSpacing: "-0.5px",
      [breakpoints.down("xs")]: {
        fontSize: "1.5rem",
        lineHeight: "1.5rem"
      }
    },
    h4: {
      fontSize: "1.3125rem",
      lineHeight: "1.875rem",
      fontWeight: 400,
      color: color.dark,
      [breakpoints.down("xs")]: {
        fontSize: "1.25rem",
        lineHeight: "1.5rem"
      }
    },
    h5: {
      fontSize: "1.125rem",
      fontWeight: 400,
      color: color.primary,
      letterSpacing: "0.25px",
      [breakpoints.down("xs")]: {
        fontSize: "1rem",
        lineHeight: "1rem"
      }
    },
    h6: {
      fontSize: "7.5rem",
      fontWeight: 300,
      lineHeight: "6.875rem",
      letterSpacing: "-2px",
      [breakpoints.down("sm")]: {
        fontSize: "5rem",
        lineHeight: "5rem"
      },
      [breakpoints.down("xs")]: {
        fontSize: "3.875rem",
        lineHeight: "3.875rem"
      }
    },
    subtitle1: {},
    subtitle2: {
      fontSize: "1rem",
      fontWeight: 400,
      fontFamily: "Poppins",
      color: color.dark
    }, //nav item
    body1: {
      fontFamily: "Nunito Sans",
      fontWeight: 400,
      fontSize: "1.125rem",
      lineHeight: "1.625rem",
      color: color.dark,
      [breakpoints.down("xs")]: {
        lineHeight: "1.25rem"
      }
    },
    body2: {
      fontFamily: "Nunito Sans",
      fontWeight: 400,
      fontSize: "1rem",
      color: color.dark
    },
    caption: {
      fontFamily: "Nunito Sans",
      fontSize: "0.75rem",
      fontWeight: 400,
      color: color.dark
    },
    button: {
      textTransform: "none",
      fontFamily: "Poppins",
      fontWeight: 400,
      fontSize: "1.125rem",
      color: color.dark
    }
  },
  palette: {
    primary: {
      main: color.primary,
      contrastText: "white"
    },
    secondary: {
      main: color.secondary
    }
  },
  // https://material-ui.com/customization/themes/
  overrides: {}
})
